<template>
    
    <div class="puzzle-countdown-container">
        
        <va-progress-bar
            :size="24"
            :model-value="mins"
        />

       <div class="countdown-info"> 
           {{ `剩余${formattedMins}s`}}
        </div>
    </div>
</template>

<script>

    import { 
        reactive,
        toRefs, 
        getCurrentInstance, 
        computed,
        onMounted,
        onUnmounted,
        watch 
    } from "vue";

    export default {
        name: "PuzzleCountdown",
        props: {
            isSuccess: {
                type: Boolean
            },
            toStartTimer: {
                type: Boolean
            }
        },
        setup(props) {

            onUnmounted(() => {
                resetTimer();
            });

            onMounted(() => {
                initTimer();
            });

            watch(() => props.isSuccess, value => {

                if (value) {
                    pauseTimer();
                }
            });

            watch(() => props.toStartTimer, value => {

                if (!value) {
                    return;
                }

                startTimer();
            })

            const _this = getCurrentInstance().appContext.config.globalProperties;

            const { TIME, EVENT, ENUM } = _this.$constants;

            const state = reactive({
                mins: 0,
                timer: null
            });

            const formattedMins = computed(() => {

                const { mins } = state;

                return mins >= 10 || mins === 0? `${mins}` : `0${mins}`;
            });

            const initTimer = () => {
                state.mins = TIME.MAX_TIME_ALLOWED;
            }

            const startTimer = () => {

                state.timer = setInterval(() => {

                    if (state.mins > 0) {
                        state.mins -= 1;
                    } else {

                        _this.$bus.$emit(EVENT.END_OPERATION, {
                            type: ENUM.END_OPERATION.TIME_OUT
                        });
                        
                        pauseTimer();
                    }
                }, TIME.ONE_SEC);
            }

            const pauseTimer = () => {
                clearInterval(state.timer);
            };

            const resetTimer = () => {

                initTimer();

                pauseTimer();
            };

            return {
                ...toRefs(state),
                formattedMins
            }
        }
    }
</script>

<style lang="scss" scoped>

    .puzzle-countdown-container {

        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        color: #3E6DB3;
        font-weight: 400;
        line-height: 5px;
        position: fixed;
        left: 8%;

        div:nth-of-type(1) {
            width: 65%;
            margin-right: 0.6rem;
        }

        .countdown-info {
            position: absolute;
            top: 30%;
            right: 16.5%;
        }
    }

    @media screen and (min-height: 800px) {
         .puzzle-countdown-container {
            top: 10.2rem;
        }
    }

    @media screen and (max-height: 800px) {
        
        .puzzle-countdown-container {
            top: 6.8rem;
        }
    }
</style>

<style lang="scss">

    .puzzle-countdown-container {

        .va-progress-bar__wrapper {
            border: 3px solid #57ACFF !important;
            background-color: #8CC5FF !important;
        }

        .va-progress-bar__progress {
            background: linear-gradient(
                -60deg, 
                #87EC3D 0, #87EC3D 5%, 
                #00C300 5%, #00C300 10%, 
                #87EC3D 10%, #87EC3D 15%, 
                #00C300 15%, #00C300 20%,
                #87EC3D 20%, #87EC3D 25%, 
                #00C300 25%, #00C300 30%,
                #87EC3D 30%, #87EC3D 35%,
                #00C300 35%, #00C300 40%,
                #87EC3D 40%, #87EC3D 45%,
                #00C300 45%, #00C300 50%,
                #87EC3D 50%, #87EC3D 55%, 
                #00C300 55%, #00C300 60%, 
                #87EC3D 60%, #87EC3D 65%, 
                #00C300 65%, #00C300 70%,
                #87EC3D 70%, #87EC3D 75%, 
                #00C300 75%, #00C300 80%,
                #87EC3D 80%, #87EC3D 85%,
                #00C300 85%, #00C300 90%,
                #87EC3D 90%, #87EC3D 95%,
                #00C300 95%, #00C300 100%
            );
        }
    }

    @media screen and (max-height: 800px) {
        
        .puzzle-countdown-container {

            .va-progress-bar__wrapper {
                height: 14px;
            }
        }
    }
</style>